import service from '@/services/company-type/CompanyTypeService'

export const companyTypeModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    companyTypeList: [],
  },
  mutations: {
    SET_LIST(state, payload) {
      state.companyTypeList = payload.data ?? payload
    },
  },
  actions: {
    async getCompanyTypes({ commit }, payload) {
      let response = await service.getCompanyTypes(payload)
      commit('SET_LIST', response)
    },
  },
  getters: {
    getComboBoxList: (state) => {
      return state.companyTypeList
        ? state.companyTypeList.map((companyType) => companyType.TIPO)
        : []
    },
    getComboBoxGrupoList: (state) => {
      return state.companyTypeList
        ? state.companyTypeList.map((companyType) => companyType.GRUPOPLANO)
        : []
    },
    getCompanyTypeList: (state) => {
      return state.companyTypeList
    },
  },
}
